export interface IGetRwgConfigResponseBase {
  addressLine: string;
  mediaUrl?: string;
  name: string;
}

export interface IGetRwgConfigErrorResponse {
  message: string;
  retryable?: boolean;
}

export interface IGetRwgConfigResponseV1 extends IGetRwgConfigResponseBase {
  clientKey: string;
  flowKey?: string;
}

export interface IGetRwgConfigResponseV2 extends IGetRwgConfigResponseBase {
  schedulerSrc: string;
}

export interface IClientState {
  data?: IGetRwgConfigResponseV1 | IGetRwgConfigResponseV2;
  requestSuccess: boolean;
}

// New types for routing
export enum RouteType {
  Token = "token",
  AbandonedSession = "abandoned-session",
}

export interface ITokenRouteParams {
  type: RouteType.Token;
  token: string;
  isGbpId: boolean;
}

export interface IAbandonedSessionRouteParams {
  type: RouteType.AbandonedSession;
  abandonedSessionId: string;
}

export type IRouteParams = ITokenRouteParams | IAbandonedSessionRouteParams;
